export const CommonBatchManagementCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione Batch',
    path: '/sistema/gestione-batch',
  },
];
